import React from 'react';
import { FileText, ShieldCheck, TerminalSquare, Video, Calculator, Users, Gift } from 'lucide-react';
export function Bundle() {
  const bonuses = [{
    icon: <FileText className="w-6 h-6 text-blue-400" data-id="element-1" />,
    title: 'Bono 1: Plantillas Cierra-Clientes',
    desc: 'Propuestas comerciales pre-escritas que funcionan y convierten curiosos en clientes que pagan.',
    value: '$25.000 ARS'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-green-400" data-id="element-2" />,
    title: 'Bono 2: Guía Anti-Comisiones',
    desc: 'El método legal y seguro para cobrar tus dólares al valor del Blue sin perder fortunas en comisiones.',
    value: '$15.000 ARS'
  }, {
    icon: <TerminalSquare className="w-6 h-6 text-purple-400" data-id="element-3" />,
    title: 'Bono 3: La Bóveda de los 100 Prompts Maestros',
    desc: 'Instrucciones secretas de copiar y pegar para que la IA haga el 90% del trabajo por vos.',
    value: '$35.000 ARS'
  }, {
    icon: <Video className="w-6 h-6 text-pink-400" data-id="element-4" />,
    title: "Bono 4: Masterclass 'Primer Cliente en 7 Días'",
    desc: 'Paso a paso en video mostrando exactamente cómo conseguir tu primer pago en USD esta misma semana.',
    value: '$40.000 ARS'
  }, {
    icon: <Calculator className="w-6 h-6 text-yellow-400" data-id="element-5" />,
    title: 'Bono 5: Tracker Financiero',
    desc: 'Plantilla premium de Notion/Excel para organizar tus ingresos en USD y tus gastos en ARS.',
    value: '$10.000 ARS'
  }, {
    icon: <Users className="w-6 h-6 text-cyan-400" data-id="element-6" />,
    title: 'Bono 6: Comunidad Privada en Telegram',
    desc: 'Acceso de por vida a la red de freelancers argentinos donde compartimos clientes, tips y soporte.',
    value: '$25.000 ARS'
  }];
  return <section className="py-24 bg-slate-900 border-y border-slate-800 relative" data-id="element-7">
      <div className="container mx-auto px-4" data-id="element-8">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-9">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-purple-500/10 border border-purple-500/30 text-purple-400 text-sm font-bold mb-6" data-id="element-10">
            <Gift className="w-4 h-4" data-id="element-11" />
            OFERTA ESPECIAL DE LANZAMIENTO
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-12">
            Todo lo que te llevás hoy
          </h2>
          <p className="text-xl text-slate-400" data-id="element-13">
            Además del Ebook principal{' '}
            <span className="text-white font-bold" data-id="element-14">"Dólares con IA"</span>, te
            llevás estos 6 bonos de alto valor{' '}
            <span className="text-green-400 font-bold" data-id="element-15">TOTALMENTE GRATIS</span>{' '}
            con tu compra hoy.
          </p>
        </div>

        {/* Main Ebook Showcase */}
        <div className="max-w-4xl mx-auto mb-16 flex flex-col md:flex-row items-center gap-10 bg-slate-950 rounded-3xl border border-purple-500/30 p-8 md:p-12 shadow-[0_0_40px_rgba(168,85,247,0.1)]" data-id="element-16">
          <div className="w-64 md:w-72 flex-shrink-0" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/micWk5RW6PJcaWSoxYemC4/hf_20260326_204901_acc85935-8bf7-41d8-b6f9-083e501208d9.jpg" alt="Dólares con IA - El Blueprint para Freelancers Argentinos" className="w-full h-auto rounded-xl shadow-2xl shadow-purple-500/20" data-id="element-18" />
          </div>
          <div className="text-center md:text-left" data-id="element-19">
            <span className="inline-block bg-purple-500/20 text-purple-300 text-xs font-bold px-3 py-1 rounded-full mb-4 uppercase tracking-wider" data-id="element-20">
              Ebook Principal
            </span>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-21">
              Dólares con IA
            </h3>
            <p className="text-lg text-slate-300 mb-2 font-medium" data-id="element-22">
              El Blueprint para Freelancers Argentinos
            </p>
            <p className="text-slate-400 leading-relaxed" data-id="element-23">
              El sistema paso a paso para usar Inteligencia Artificial y generar
              ingresos en dólares desde Argentina. Todo lo que necesitás saber
              para empezar a facturar al mundo.
            </p>
          </div>
        </div>

        {/* Bonus Title */}
        <div className="text-center mb-10" data-id="element-24">
          <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-25">
            + 6 Bonos de Alto Valor{' '}
            <span className="text-green-400" data-id="element-26">GRATIS</span>
          </h3>
        </div>

        {/* Bonus Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-27">
          {bonuses.map((bono, idx) => <div key={idx} className="bg-slate-950 p-6 rounded-2xl border border-slate-800 hover:border-purple-500/50 transition-all duration-300 hover:-translate-y-1 relative overflow-hidden group" data-id="element-28">
              <div className="absolute top-0 right-0 bg-slate-800 text-slate-300 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-29">
                Valor: {bono.value}
              </div>
              <div className="w-12 h-12 bg-slate-900 rounded-xl flex items-center justify-center mb-4 border border-slate-800 group-hover:border-purple-500/30 transition-colors" data-id="element-30">
                {bono.icon}
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-31">
                {bono.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed" data-id="element-32">
                {bono.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}